import React, { useEffect, useState } from "react";
import Card from "../../../Components/share/cards/Card";
import AdminPagination from "../../../Components/share/Pageination/AdminPagination";
import { BtnAlternative } from "../../../Components/share/buttons/Btn";
import moment from "jalali-moment";

function MeetingTable(props) {
    const [dateTime, setDateTime] = useState("");

    useEffect(() => {
        const dateTime = moment()
            .locale("fa")
            .format("ddd DD MMMM YYYY HH:mm:ss");
        setDateTime(dateTime);
    }, []);

    return (
        <div className="mx-24 py-24">
            <Card className="SupportTicketTable-card SupportTicketTable-header ">
                {props.header.map((item, id) => (
                    <div>{item.title}</div>
                ))}
            </Card>
            {props.list.map((item, index) => (
                <Card
                    key={item?.id}
                    className="SupportTicketTable-card SupportTicketTable-body  my-4"
                >
                    <div>{item?.session_name}</div>
                    <div>
                        {moment(item?.session_start_time)
                            .locale("fa")
                            .format("ddd DD MMMM YYYY HH:mm:ss")}
                    </div>

                    <div>
                        <p
                            className=" text-[#77498F] font-normal text-[1.2rem] leading-[2.4rem] cursor-pointer"
                            onClick={() => {
                                props.setSelectedSession(item.id);
                                props.showModal(true);
                            }}
                        >
                            ارسال پاسخ تکلیف
                        </p>
                    </div>
                    <div>
                        <BtnAlternative
                            text={"فایل ها"}
                            className="px-10 py-6 self-center"
                            onClick={() => {
                                props.show(true);
                                props.setSelectedSession(item.id);
                            }}
                        />
                    </div>
                </Card>
            ))}

            {props.children}
        </div>
    );
}

export default MeetingTable;
